import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import ContentTypeList from './ContentTypeList';
import ContentTypeEntries from './ContentTypeEntries';
import ContentEntry from './ContentEntry';

class Content extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/edit" component={ContentTypeList} />
        <Route exact path="/edit/:schemaId" component={ContentTypeEntries} />
        <Route
          exact
          path="/edit/:schemaId/:entryId"
          component={ContentTypeEntries}
        />
        {/* <Route exact path="/edit/:schemaId/:entryId" component={ContentEntry} /> */}
      </Switch>
    );
  }
}

export default connect(
  state => ({}),
  {}
)(Content);
